<template>
  <div>
    <el-row :gutter="20">
      <el-col :span="24">
        <div class="find">
          <div class="seach-top">
            <el-form ref="searchForm" :inline="true" :model="searchForm" class="demo-form-inline">
              <el-form-item label="关键字:">
                <el-input v-model="searchForm.keyWord" style="width:140px" placeholder="查询关键字" size="small" clearable />
              </el-form-item>
              <el-form-item>
                <el-button type="primary" size="small" @click="handleSearch">
                  查询
                </el-button>
              </el-form-item>
              <div class="btn-box" style="float: right;">
                <el-form-item>
                  <el-button type="primary" size="small" @click="handleAdd(null,null)">
                    新增
                    <i class="el-icon-plus el-icon--right" />
                  </el-button>
                </el-form-item>
                <el-form-item>
                  <el-button style="margin-left: 8px" size="small" type="primary" @click="handleExport()">
                    导出
                    <i class="el-icon-download el-icon--right" />
                  </el-button>
                </el-form-item>
              </div>
            </el-form>
          </div>
        </div>

      </el-col>

    </el-row>

    <el-table
      :data="tableData"
      style="width: 100%;margin-bottom: 20px;"
      row-key="id"
      border
      default-expand-all
      :tree-props="{children: 'children'}"
    >
      <el-table-column prop="workTaskName" label="任务名称" sortable width="180" :show-overflow-tooltip="true" />
      <el-table-column prop="isAuditByParent" label="父审" width="50" align="center">
        <template slot-scope="scope">
          <i v-if="scope.row.isAuditByParent" class="el-icon-star-on" />
        </template>
      </el-table-column>
      <el-table-column prop="fangAnStatusDictKeyItemName" label="方案" width="50" />
      <el-table-column prop="beginDateShow" label="开始日期" sortable width="110" />
      <el-table-column prop="endDateShow" label="结束日期" sortable width="110" />
      <el-table-column prop="leaderName" label="负责人" sortable width="100" />
      <el-table-column prop="workTaskStatusDictKeyItemName" label="状态" sortable width="150">
        <template slot-scope="scope">
          <span>{{ scope.row.workTaskStatusDictKeyItemName }}</span>
          <span v-if="scope.row.auditingType > 0">(审核中)</span>
        </template>
      </el-table-column>
      <el-table-column prop="auditingUserName" label="审核者" sortable width="100">
        <template slot-scope="scope">
          <span>{{ scope.row.auditingUserName }}</span>
          <span v-if="scope.row.auditingType === 1">(本级)</span>
          <span v-else-if="scope.row.auditingType ===2 ">(父级)</span>
          <span v-else-if="scope.row.auditingType ===3 ">(课题级)</span>
        </template>

      </el-table-column>
      <el-table-column prop="workTaskDescribe" label="任务描述" sortable min-width="180" :show-overflow-tooltip="true" />

      <el-table-column fixed="right" label="操作" width="250" align="center">
        <template slot-scope="scope">
          <span>
            <el-button type="text" size="mini" plain @click.stop="handleTaskFollow( scope.row.id,scope.row.parentId)">跟进</el-button>
            <el-button type="text" size="mini" plain @click.stop="handleAdd( null,scope.row.id)">添加子任务</el-button>
            <el-button v-if="scope.row.isHasPermAudit" type="text" size="mini" plain @click.stop="handleTaskAudit( scope.row.id,scope.row.parentId)">审核</el-button>
            <el-button v-if="scope.row.isCanDelete" type="text" size="mini" plain @click.stop="handleTaskDoDelete( scope.row)">删除</el-button>
          </span>
        </template>
      </el-table-column>

    </el-table>

    <!-- <el-pagination background layout="prev, pager, next,total,sizes" :page-sizes="[10, 20, 50, 100]" :page-size="10" :total="totalCount" @size-change="handleSizeChange" @current-change="handleChangePage" /> -->
    <WorkTaskEdit ref="editForm" :entity-id="taskId" :parent-id="parentId" :module-code="moduleCode" :module-key="moduleKey" @save-success="handleSearch" />
    <WorkEventNodeFollow
      ref="followForm"
      :entity-id="taskId"
      :module-code="moduleCode"
      :module-key="moduleKey"
      @save-success="handleSearch"
      @ToEdit="(id)=>{handleEdit(id)}"
    />
    <TaskAudit
      ref="followAudit"
      :entity-id="taskId"
      :module-code="moduleCode"
      :module-key="moduleKey"
      @save-success="handleSearch"
    />
  </div>
</template>

<script>
import pathReq from '@/api/pathlist'
import KxjCom from '@/utils/kxjcom'
import WorkTaskEdit from './WorkTaskEdit'
import WorkEventNodeFollow from './WorkTaskFollow'
import TaskAudit from './WorkTaskAudit'
export default {
  components: { WorkTaskEdit, WorkEventNodeFollow, TaskAudit },
  data() {
    return {
      moduleCode: '',
      moduleKey: null,
      taskId: null,
      parentId: null,
      totalCount: 0,
      tableData: [],
      allComboxData: [],
      searchForm: {
        keyWord: '',
        pageNumber: 1,
        pageSize: 10,
        sortKey: '',
        sortOrder: '',
        moduleCode: '',
        moduleKey: null
      }

    }
  },
  created() {

  },
  methods: {
    init() {
      this.moduleCode = this.$route.params.moduleCode
      this.moduleKey = this.$route.params.id
      this.searchForm.moduleCode = this.moduleCode
      this.searchForm.moduleKey = this.moduleKey
      this.handleSearch()
    },
    // 每页
    handleSizeChange(val) {
      this.searchForm.pageSize = val
      this.handleSearch()
    },
    // 切页
    handleChangePage(page) {
      this.searchForm.pageNumber = page
      this.handleSearch()
    },
    // 查询
    handleSearch() {
      const that = this
      const loading = this.$loading(KxjCom.loadOptions)
      const path = '/api/services/app/WorkTask/GetPagedListWorkTasks'
      pathReq
        .getList(path, that.searchForm)
        .then(res => {
          loading.close()
          that.tableData = res.data.result
        })
    },
    handleTaskFollow(id, parentId) {
      this.taskId = id
      this.parentId = parentId
      this.$refs.followForm.show()
    },
    handleTaskAudit(id, parentId) {
      this.taskId = id
      this.parentId = parentId
      this.$refs.followAudit.show()
    },
    handleAdd(id, parentId) {
      this.taskId = id
      this.parentId = parentId
      this.$refs.editForm.show()
    },
    handleEdit(id) {
      this.taskId = id
      this.parentId = null
      this.$refs.editForm.show(id)
    },
    /** 删除任务 */
    handleTaskDoDelete(row) {
      const that = this
      this.$confirm('确定要删除该任务吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$loading(KxjCom.loadOptions)
        const path = '/api/services/app/WorkTask/DeleteWorkTask'
        pathReq.dataDelete(path, row.id).then(res => {
          this.$message.success('删除成功!')
          that.handleSearch()
        })
      }).catch(() => {
      })
    }

  }
}
</script>

<style lang="scss" scoped>
  .custom-tree-node {
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: 18px;
    padding-right: 8px;
  }
</style>
